import "./style.css";
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from "react-accessible-accordion";
import { RiArrowDownSLine } from "react-icons/all";

const faqSections = [
  {
    title: "About CapitalPay",
    items: [
      {
        question: "What is CapitalPay?",
        answer: (
          <>
            <p>
              CapitalPay is your digital wallet, created to enable payments and
              money transfers from your phone 24/7, without the need to visit a
              branch every time.
            </p>
            <p>
              CapitalPay is a product of IFJB Capital SH.P.K., an institution
              licensed by the Central Bank of Kosovo.
            </p>
            <p>
              With CapitalPay, you can make bill payments and business
              payments, receive and send money, and at the same time track your
              transactions and manage your money more easily, faster, and more
              securely.
            </p>
          </>
        ),
      },
      {
        question: "Why use CapitalPay?",
        answer: (
          <>
            <p>
              CapitalPay saves you time and gives you access to payments
              wherever you are. You do not need to wait in line, carry bills
              with you, or physically visit a location for every payment.
            </p>
            <p>
              Through the application, you can make payments 24/7, directly
              from your phone.
            </p>
          </>
        ),
      },
      {
        question: "What services can I use with CapitalPay?",
        answer: (
          <>
            <p>Through CapitalPay, you can make payments for:</p>
            <ul>
              <li>police fines;</li>
              <li>internet and TV;</li>
              <li>water bills;</li>
              <li>taxes and contributions;</li>
              <li>other domestic payments;</li>
              <li>payments in stores/businesses;</li>
              <li>money transfers;</li>
              <li>account top-ups.</li>
            </ul>
            <p>
              The list of services may be updated over time, depending on new
              services added to the application.
            </p>
          </>
        ),
      },
    ],
  },
  {
    title: "Account Opening",
    items: [
      {
        question: "How can I open an account in CapitalPay?",
        answer: (
          <>
            <p>To open an account:</p>
            <ul>
              <li>Download the CapitalPay application.</li>
              <li>Enter your phone number.</li>
              <li>Confirm the code you receive by SMS.</li>
              <li>Complete the required information.</li>
              <li>Complete the identity verification process.</li>
              <li>Wait for account approval.</li>
            </ul>
            <p>After approval, you can start using CapitalPay.</p>
          </>
        ),
      },
      {
        question: "What do I need to register?",
        answer: (
          <>
            <p>To register, you need:</p>
            <ul>
              <li>an active phone number;</li>
              <li>an email address;</li>
              <li>an identification document;</li>
              <li>a photo/selfie for verification;</li>
              <li>proof of residential address.</li>
            </ul>
            <p>
              The information must be accurate, and the document must be valid.
            </p>
          </>
        ),
      },
      {
        question: "Can I open a business account in CapitalPay?",
        answer: (
          <>
            <p>
              Yes. With CapitalPay, you can also create an account for your
              business.
            </p>
            <p>
              A business account allows you to receive payments from customers
              through CapitalPay in a simple and secure way.
            </p>
          </>
        ),
      },
      {
        question:
          "Can I use CapitalPay with a phone number from outside Kosovo?",
        answer: (
          <p>
            Currently, CapitalPay can only be used with a Kosovo phone number
            with the +383 prefix. The CapitalPay application can be accessed
            from any country in Europe.
          </p>
        ),
      },
    ],
  },
  {
    title: "Verification",
    items: [
      {
        question: "Why is identity verification required?",
        answer: (
          <p>
            Verification is performed for your security and to prevent misuse of
            accounts. This is a necessary step for digital financial services.
          </p>
        ),
      },
      {
        question: "How long does account approval take?",
        answer: (
          <p>
            Approval may take time depending on the workload and the accuracy
            of the information you have submitted. If the documents are clear
            and the information is accurate, the process is usually completed
            very quickly.
          </p>
        ),
      },
      {
        question: "Can my account be rejected?",
        answer: (
          <>
            <p>An account may not be approved if:</p>
            <ul>
              <li>the document is unclear;</li>
              <li>the photo does not match the document;</li>
              <li>the information has been entered incorrectly;</li>
              <li>the document has expired;</li>
              <li>required information is missing.</li>
            </ul>
            <p>
              In this case, you may be asked to correct the information or
              submit the documents again.
            </p>
          </>
        ),
      },
    ],
  },
  {
    title: "Account Top-Up",
    items: [
      {
        question: "How can I top up my account?",
        answer: (
          <>
            <p>
              To top up your CapitalPay account, you can use one of the
              following methods:
            </p>
            <p>1. At Capital branches:</p>
            <ul>
              <li>Visit one of the Capital branches in Kosovo.</li>
              <li>
                Inform the operator that you want to top up your CapitalPay
                account.
              </li>
              <li>
                You must have an identification document with you, such as an
                ID card, passport, or driver's license.
              </li>
              <li>
                Hand over the amount you want to add to your account, and the
                funds will be transferred immediately to your CapitalPay
                account.
              </li>
            </ul>
            <p>No commission, available at more than 200 locations across Kosovo.</p>
            <p>2. Through bank transfer:</p>
            <ul>
              <li>
                Open your bank's eBanking or mBanking application and select
                the “National Transfer” option or a similar option, depending
                on your bank.
              </li>
              <li>
                In the beneficiary account field, enter the IBAN of your
                CapitalPay account.
              </li>
              <li>
                In the description field, you may write “transfer” or “account
                top-up”.
              </li>
            </ul>
            <p>
              Once the funds are received by CapitalPay, they will be
              transferred immediately to your electronic account.
            </p>
            <p>
              Bank transfers are processed according to the processing times of
              the sending bank and the interbank system.
            </p>
          </>
        ),
      },
    ],
  },
  {
    title: "Withdrawal of Funds from the Account",
    items: [
      {
        question: "How can I withdraw funds from my account?",
        answer: (
          <>
            <p>
              To withdraw funds from your CapitalPay account, you can use one of
              the following methods:
            </p>
            <p>1. At Capital branches</p>
            <ul>
              <li>Visit one of the Capital branches in Kosovo.</li>
              <li>
                Inform the operator that you want to withdraw money from your
                CapitalPay account.
              </li>
              <li>
                You must have an identification document with you, such as an
                ID card, passport, or driver's license.
              </li>
            </ul>
            <p>
              The service fee for withdrawing funds from CapitalPay at any
              Capital branch is only €0.50.
            </p>
            <p>2. Through bank transfer</p>
            <ul>
              <li>On the home page, click the “Withdrawal” button.</li>
              <li>
                Add a bank account to which you want to transfer your funds.
                Make sure to enter the correct account details by completing
                the displayed fields.
              </li>
              <li>
                After creating the account, you can select that account to
                transfer your funds by choosing the beneficiary account.
              </li>
              <li>
                Complete the required information and click the button to
                continue. A transfer confirmation window will then appear,
                where you can check whether all details are correct before
                completing the withdrawal.
              </li>
            </ul>
          </>
        ),
      },
    ],
  },
  {
    title: "Payments",
    items: [
      {
        question: "How do I pay a bill in CapitalPay?",
        answer: (
          <>
            <p>
              You can pay a bill by scanning the barcode or QR code through the
              scanning option on the home page.
            </p>
            <p>Or:</p>
            <p>On the home page, select the “Pay Bills” option.</p>
            <ul>
              <li>Select the payment category.</li>
              <li>Enter the required information.</li>
              <li>Check the amount and details.</li>
              <li>Confirm the payment.</li>
            </ul>
          </>
        ),
      },
      {
        question: "How can I pay in stores?",
        answer: (
          <>
            <p>
              After selecting the “Pay in Stores” option on the home page:
            </p>
            <ol>
              <li>
                Select the store you want to pay by searching for it by name or
                by choosing it from the list.
              </li>
              <li>Pay by scanning the QR code displayed in the store.</li>
              <li>Pay through the store's phone number.</li>
            </ol>
          </>
        ),
      },
      {
        question: "Where can I find proof of payment?",
        answer: (
          <p>
            You can find proof of payment on the home page or in the
            transaction history.
          </p>
        ),
      },
      {
        question: "Can I cancel a payment after confirming it?",
        answer: (
          <p>
            In most cases, confirmed payments cannot be cancelled. If you have
            made a mistake, contact CapitalPay support immediately.
          </p>
        ),
      },
    ],
  },
  {
    title: "Transfers",
    items: [
      {
        question: "Can I send or receive money with CapitalPay?",
        answer: (
          <>
            <p>
              Yes. CapitalPay enables you to send and receive money to and from
              another CapitalPay user through a phone number, account number,
              or QR code.
            </p>
            <p>You can also transfer money to bank accounts.</p>
          </>
        ),
      },
    ],
  },
  {
    title: "Accessing the Application",
    items: [
      {
        question: "How do I log in to CapitalPay?",
        answer: (
          <p>
            You can log in to the application using your phone number and the
            password you have created.
          </p>
        ),
      },
      {
        question: "Can I log in with Face ID or fingerprint?",
        answer: (
          <p>
            Yes. If your phone supports this function, you can activate
            biometric identification for faster and more secure login.
          </p>
        ),
      },
      {
        question: "I forgot my password. What should I do?",
        answer: (
          <p>
            Use the “Reset Password” option in the application through SMS or
            email, or contact support.
          </p>
        ),
      },
      {
        question: "I changed my phone. Can I access my account again?",
        answer: (
          <p>
            Yes. Download the application on your new phone and log in using
            your phone number.
          </p>
        ),
      },
    ],
  },
  {
    title: "Fees",
    items: [
      {
        question: "Is there a fee for opening an account?",
        answer: <p>Account opening is free of charge.</p>,
      },
      {
        question: "Is there a monthly maintenance fee?",
        answer: (
          <p>
            CapitalPay has no monthly account maintenance fee. Fees may apply
            only for certain services, according to the official price list.
          </p>
        ),
      },
      {
        question: "Where can I see the fees?",
        answer: (
          <p>
            Fees should be displayed before confirming the transaction or in
            the official CapitalPay price list. Before making a payment, check
            whether any fee applies.
          </p>
        ),
      },
    ],
  },
  {
    title: "Security",
    items: [
      {
        question: "Is CapitalPay secure?",
        answer: (
          <>
            <p>
              Yes. CapitalPay uses security measures to protect your account,
              data, and transactions.
            </p>
            <p>
              For higher security, do not share your password or the
              verification code you receive by SMS with anyone.
            </p>
          </>
        ),
      },
      {
        question: "What should I do if I suspect misuse?",
        answer: (
          <p>
            If you notice unknown transactions or suspect that someone has
            access to your account, contact CapitalPay support immediately.
          </p>
        ),
      },
    ],
  },
  {
    title: "Support",
    items: [
      {
        question: "How can I get help?",
        answer: (
          <>
            <p>
              For help regarding CapitalPay, you can contact support through
              the official channels:
            </p>
            <ul>
              <li>Tel: 038 600 003</li>
              <li>Email: info@capital-ks.com</li>
            </ul>
            <p>
              Support can assist you with registration, verification, payments,
              transfers, account access, and possible technical issues.
            </p>
          </>
        ),
      },
    ],
  },
];

function FrequentlyAskedQuestions() {
  return (
    <div id="wrapper-page">
      <div id="first_page">
        <h1>Help / Frequently Asked Questions</h1>
        {faqSections.map((section) => (
          <div key={section.title} className="faq-section">
            <h2>{section.title}</h2>
            <Accordion allowZeroExpanded>
              {section.items.map((item) => (
                <AccordionItem key={item.question}>
                  <AccordionItemHeading>
                    <AccordionItemButton>
                      {item.question}
                      <RiArrowDownSLine />
                    </AccordionItemButton>
                  </AccordionItemHeading>
                  <AccordionItemPanel>{item.answer}</AccordionItemPanel>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        ))}
      </div>
    </div>
  );
}

export default FrequentlyAskedQuestions;
